import { render, staticRenderFns } from "./OrganAllocationReportHtmlPrint.vue?vue&type=template&id=34a65026&scoped=true"
import script from "./OrganAllocationReportHtmlPrint.vue?vue&type=script&lang=js"
export * from "./OrganAllocationReportHtmlPrint.vue?vue&type=script&lang=js"
import style0 from "./OrganAllocationReportHtmlPrint.vue?vue&type=style&index=0&id=34a65026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a65026",
  null
  
)

export default component.exports